import React from 'react';
import PropTypes from 'prop-types'

const Box = ({ large, giant, children, color, className }) => {
  let classes = large ? ['largebox', 'box'] : ['box'];
  if (giant) {
    classes = ['giantbox', 'box'];
  }
  if (color > 0) {
    classes.push(`color-${color}`);
  }
  if (className.length > 0) {
    classes.push(className);
  }
  return (
    <div className={classes.join(' ')}>
      {children}
    </div>
  );
};

Box.propTypes = {
  large: PropTypes.bool,
  giant: PropTypes.bool,
  color: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Box;



// WEBPACK FOOTER //
// ./src/components/box.js